<!--

NOTE: The :key="client" makes the whole container 'another one' when new data is being passed to this component.
Which means Vue will re-render it when doing straight from one case to another. See:
    <div class="view case-page light" :key="client">
Otherwise it just sees an Object and thinks it's cool that it's the same Object as it has, without looking inside it.
Sort of..

-->

<template>
<div class="view case-page"
     :key="id">

    <!-- <CaseViewPrevNext :index="index" /> -->

    <div class="view__inner">

        <CaseViewHero :msg="heroText"
                      :client="client"
                      :imageLandscape="imageLandscape"
                      :imagePortrait="imagePortrait" />

        <div class="case-page__content">

            <CaseViewDescription :client="client"
                                 :deliverables="deliverables"
                                 :description="description"
                                 :link="link" />

            <slot>
                <!-- Here goes the components for the cases -->
            </slot>

        </div>

        <CaseBanner />

        <TheSiteFooterNew />

    </div>

</div>
</template>

<script>
import {
    mapState
} from 'vuex'
// import Scrollbar from 'smooth-scrollbar'
import CaseViewHero from '@/components/CaseViewHero.vue'
import CaseViewPrevNext from '@/components/CaseViewPrevNext.vue'
import CaseViewDescription from '@/components/CaseViewDescription.vue'
import CaseBanner from '@/components/CaseBanner.vue'
import TheSiteFooterNew from '@/components/TheSiteFooterNew'

export default {
    name: 'CaseViewBaseLayout',
    components: {
        CaseViewHero,
        CaseViewPrevNext,
        CaseViewDescription,
        CaseBanner,
        TheSiteFooterNew
    },
    props: {
        id: Number
    },
    data() {
        return {
            footerHeight: this.$store.state.footerHeight,
        }
    },
    computed: mapState({
        isMobile: state => state.globals.isMobile,
        cases(state) {
            return state.data.cases
        },
        currentCase(state) {
            return state.data.cases.find(item => item.id === this.id)
        },

        heroText() {
            return this.currentCase.info.subTitle
        },
        imageLandscape() {
            return this.currentCase.info.imageLandscape
        },
        imagePortrait() {
            return this.currentCase.info.imagePortrait
        },
        client() {
            return this.currentCase.info.title
        },
        deliverables() {
            return this.currentCase.info.deliverables
        },
        description() {
            return this.currentCase.info.description
        },
        link() {
            return this.currentCase.info.link
        },
        darkText() {
            return this.currentCase.info.darkText
        }
    }),
    watch: {
        id: {
            immediate: true,
            handler(id) {
                this.getCurrentOrder(id)
            }
        }
    },
    methods: {
        getCurrentOrder(id) {
            //helpers
            const isFirst = i => i === 0
            const isLast = i => i === this.cases.length - 1
            const isNextToLast = i => i === this.cases.length - 2
            const oneDown = i => i - 1
            const oneUp = i => i + 1
            const twoUp = i => i + 2

            const previous = isFirst(id) ? this.cases.length - 1 : oneDown(id)
            const next = isLast(id) ? 0 : oneUp(id)
            const twoNext = isNextToLast(id) ? 0 : isLast(id) ? 1 : twoUp(id)

            this.$store.commit('SET_BANNER_CASES', [previous, next, twoNext])
        }
    },
    updated() {
        this.$store.commit('SET_LIGHT_THEME', this.darkText)
    },
    mounted() {
        this.$store.commit('SET_LIGHT_THEME', this.darkText)
    }
}
</script>

<style scoped lang="scss">
@import "../scss/globals.scss";

.view__inner {
    height: 100vh;
}
</style>
